var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-wrapper"},[_c('Stage'),_c('GridImg'),_c('ThreeHeadlines'),_c('TeaserVideo'),_c('AppStoreCta'),_c('Slider'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }